import { FormFieldBase } from './form-field-base';

export class FormFieldString extends FormFieldBase<string> {
  controlType = 'input';
  type = 'text';
}
